


import {AccountStatus} from './AccountStatus'; 
export class AuthResponseVM {
    
    accountStatus?: AccountStatus;
    
    message?: string;
    
    jwt?: string;
    
}
